import Uppy from "@uppy/core";
import XHRUpload from "@uppy/xhr-upload";
import { AppDashboardOptions, DefaultMeta, DefaultBody, AppUppy, DEFAULT_ALLOWED_FILE_EXTENSIONS } from "common";

export const getUppyInstance = (
  endpoint: string,
  accessToken: string
): AppUppy => {
  const uppy = new Uppy<DefaultMeta, DefaultBody>({
    debug: false,
    autoProceed: false,
    restrictions: {
      maxFileSize: 20971520, // 20MB
      maxNumberOfFiles: 10,
      allowedFileTypes: DEFAULT_ALLOWED_FILE_EXTENSIONS,
    },
  });

  uppy.use(XHRUpload, {
    endpoint,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return uppy;
};

export const updateUppyEndpoint = (uppy: AppUppy, endpoint: string): void => {
  if (!!uppy) {
    uppy.getPlugin("XHRUpload").setOptions({ endpoint });
  }
};

export const getUppyDashboardOptions = (): AppDashboardOptions => {
  return {
    id: "Dashboard",
    height: 312,
    plugins: [],
    hideUploadButton: true,
    hideRetryButton: true,
    hidePauseResumeButton: true,
    proudlyDisplayPoweredByUppy: false,
  };
};
